import { create } from 'zustand';

interface AdLoginState{
    tab : string,
    setField : (field: keyof AdLoginState, value: any) => void 
    reset : ()=>void
}

const defaultValue = {
    tab : 'Login'
}

export const useAdLoginStore = create<AdLoginState>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset : ()=>set({...defaultValue})
}))